import React from 'react';
import { Users } from 'lucide-react';

/**
 * Компонент секции параметров пассажира
 */
const PassengerParamsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  passengerTypes 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Users className="w-5 h-5 mr-2 text-purple-500" />
        Тип пассажира
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {passengerTypes.map((passengerType) => (
          <label key={passengerType.id} className={`
            block p-3 rounded-lg border cursor-pointer transition-colors
            ${formData.passengerType === passengerType.id 
              ? 'bg-purple-50 border-purple-200 dark:bg-purple-900/20 dark:border-purple-800' 
              : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
          `}>
            <div className="flex items-start">
              <input
                type="radio"
                name="passengerType"
                value={passengerType.id}
                checked={formData.passengerType === passengerType.id}
                onChange={handleInputChange}
                className="form-radio mt-1"
              />
              <div className="ml-2">
                <span className="block text-sm font-medium text-gray-900 dark:text-white">
                  {passengerType.name}
                </span>
                <span className="block text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  {passengerType.description}
                </span>
              </div>
            </div>
          </label>
        ))}
      </div>
      
      {errors.passengerType && (
        <p className="mt-2 text-xs text-red-500 dark:text-red-400">
          {errors.passengerType}
        </p>
      )}
      
      {formData.passengerType === 'infant' && (
        <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
          <p className="text-sm text-blue-700 dark:text-blue-300">
            <span className="font-medium">Примечание:</span> Младенцы до 2 лет обычно путешествуют на коленях у родителей.
            Нормы багажа для младенцев могут отличаться в разных авиакомпаниях.
          </p>
        </div>
      )}
    </div>
  );
};

export default PassengerParamsSection;